import React from 'react';
import { Container } from '../../../components/ui';

export default function FooterSection() {
  return (
    <footer className="bg-gradient-to-r from-am-green-800 via-am-accent-700 to-am-person-700 text-white py-10 shadow-lg">
      <Container>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold">Hubungi Kami</h3>
            <a href="tel:08138009505" className="mt-2 inline-block text-sm font-medium hover:underline">0813-8009-505</a>
            <p className="mt-2 text-sm">Alamat: Plaza HNI, Jalan Raya Kalimalang – Billymoon, Pondok Kelapa, Duren Sawit, Jakarta Timur</p>
          </div>

          <div className="text-center md:text-right text-sm">
            <p>© 2026 PT AMANAH MULIA NIAGA. allright reserved</p>
          </div>
        </div>
      </Container>
    </footer>
  );
}
